<script lang="ts" setup>
import { ref, onMounted, computed } from 'vue';
import { useSessionStore } from '@/store/sessionStore';
import { useRouter } from 'vue-router';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import axiosInstance from '@/plugins/axios';


const sessionStore = useSessionStore();
const router = useRouter();
const themes = ref([]);
const loading = ref(false);
const goTo = (id: string) => {
    router.push({ path: `/admin/settings/themes/edit/${id}` });
};
const deleteTheme = async (id: string) => {
    loading.value = true;
    try {
        await axiosInstance.delete(`/admin/settings/themes/${id}`);
        themes.value = themes.value.filter((theme: any) => theme._id !== id);
    } catch (error) {
        console.error(error);
    } finally {
        loading.value = false;
    }
};
const getThemes = async () => {
    loading.value = true;
    try {
        const response = await axiosInstance.get('/admin/allThemes');
        themes.value = response.data;
    } catch (error) {
        console.error(error);
    } finally {
        loading.value = false;
    }
};

onMounted(async () => {
    await getThemes();
});

</script>




<template>
    <div>
        <DataTable :value="themes" :paginator="true" :rows="10" :loading="loading">
            <Column field="name" header="Name"></Column>
            <Column header="Connected Tenant" :body="(rowData) => rowData.tenant.name"></Column>
            <Column field="actions" header="Actions">
                <template #body="slotProps">
                    <Button  @click="goTo(slotProps.data._id)" class="mr-2">
                        <template #icon>
                            <FontAwesomeIcon icon="fa-solid fa-pen-to-square" />
                        </template>
                    </Button>
                    <Button class="p-button-danger" @click="deleteTheme(slotProps.data._id)">
                        <template #icon>
                            <FontAwesomeIcon icon="fa-solid fa-trash" />
                        </template>
                    </Button>
                </template>
            </Column>
        </DataTable>
    </div>
</template>